import { FULL_TRANSLATIONS } from "./fullTranslations";

export const LANGUAGES = [
  { code: "fr", label: "Français", shortLabel: "FR", htmlLang: "fr" },
  { code: "en", label: "English", shortLabel: "EN", htmlLang: "en" },
  { code: "es", label: "Español", shortLabel: "ES", htmlLang: "es" },
  { code: "zh-CN", label: "中文", shortLabel: "中文", htmlLang: "zh-CN" },
];

const fr = {
  "Tableau de bord": ["Dashboard", "Panel", "仪表板"],
  "Membres": ["Members", "Miembros", "会员"],
  "Entrées/Sorties": ["Check-in / out", "Entradas / salidas", "出入登记"],
  "Abonnements": ["Subscriptions", "Suscripciones", "会员订阅"],
  "Parcours Santé": ["Health journey", "Seguimiento de salud", "健康计划"],
  "Historique": ["History", "Historial", "历史记录"],
  "Dépenses": ["Expenses", "Gastos", "支出"],
  "Contrôle d'accès": ["Access control", "Control de acceso", "门禁管理"],
  "Utilisateurs": ["Users", "Usuarios", "用户"],
  "À propos": ["About", "Acerca de", "关于"],
  "Remise à zéro": ["Reset", "Restablecer", "重置"],
  "Bonjour,": ["Hello,", "Hola,", "您好，"],
  "Sécurité (2FA)": ["Security (2FA)", "Seguridad (2FA)", "安全（双重验证）"],
  "Déconnexion": ["Sign out", "Cerrar sesión", "退出登录"],
  "La salle est fermée": ["The gym is closed", "El gimnasio está cerrado", "健身房已关闭"],
  "Salle ouverte": ["Gym open", "Gimnasio abierto", "健身房已开启"],
  "Journée clôturée": ["Day closed", "Día cerrado", "当天已关闭"],
  "Salle fermée": ["Gym closed", "Gimnasio cerrado", "健身房已关闭"],
  "Ouverture :": ["Opened:", "Apertura:", "开启时间："],
  "Fermeture :": ["Closed:", "Cierre:", "关闭时间："],
  "sessions aujourd'hui": ["sessions today", "sesiones hoy", "今日课程"],
  "Ouvrir la salle": ["Open the gym", "Abrir el gimnasio", "开启健身房"],
  "Réorganiser": ["Reorganize", "Reorganizar", "重新排列"],
  "Bilan mensuel PDF": ["Monthly PDF report", "Informe mensual PDF", "月度 PDF 报告"],
  "Séances du jour": ["Today’s sessions", "Sesiones de hoy", "今日课程"],
  "Aucune séance en cours actuellement.": ["No session is currently active.", "No hay sesión en curso.", "当前没有进行中的课程。"],
  "Recettes": ["Revenue", "Ingresos", "收入"],
  "Solde net": ["Net balance", "Saldo neto", "净余额"],
  "Recettes du mois": ["Monthly revenue", "Ingresos del mes", "本月收入"],
  "Membres actifs": ["Active members", "Miembros activos", "活跃会员"],
  "Abonnements actifs": ["Active subscriptions", "Suscripciones activas", "活跃订阅"],
  "Entrées aujourd’hui": ["Today’s check-ins", "Entradas de hoy", "今日入场"],
  "Revenus du mois": ["Monthly revenue", "Ingresos del mes", "本月收入"],
  "Gestion des membres": ["Member management", "Gestión de miembros", "会员管理"],
  "Nouveau membre": ["New member", "Nuevo miembro", "新会员"],
  "Rechercher par nom...": ["Search by name...", "Buscar por nombre...", "按姓名搜索..."],
  "Rechercher par téléphone...": ["Search by phone...", "Buscar por teléfono...", "按电话搜索..."],
  "Rechercher par email...": ["Search by email...", "Buscar por correo...", "按邮箱搜索..."],
  "Recherche générale...": ["Search...", "Buscar...", "搜索..."],
  "Tous": ["All", "Todos", "全部"],
  "Actifs": ["Active", "Activos", "活跃"],
  "Expirés": ["Expired", "Vencidos", "已过期"],
  "Sans abonnement": ["No subscription", "Sin suscripción", "无订阅"],
  "Trier": ["Sort", "Ordenar", "排序"],
  "Nom (A → Z)": ["Name (A → Z)", "Nombre (A → Z)", "姓名（A → Z）"],
  "Liste des membres": ["Member list", "Lista de miembros", "会员列表"],
  "Qualité des fiches": ["Profile quality", "Calidad de fichas", "资料完整度"],
  "Visage à enregistrer": ["Face to enroll", "Rostro por registrar", "待录入人脸"],
  "Visage enregistré": ["Face enrolled", "Rostro registrado", "人脸已录入"],
  "Imprimer le badge QR": ["Print QR badge", "Imprimir tarjeta QR", "打印二维码卡"],
  "Historique d’impression": ["Print history", "Historial de impresión", "打印历史"],
  "Aucune carte ou bracelet imprimé.": ["No printed card or wristband.", "Ninguna tarjeta o pulsera impresa.", "暂无已打印卡片或手环。"],
  "Dernière impression": ["Latest print", "Última impresión", "最近打印"],
  "Paiement encaissé !": ["Payment received!", "¡Pago recibido!", "付款已收！"],
  "Imprimer le reçu": ["Print receipt", "Imprimir recibo", "打印收据"],
  "Télécharger le PDF": ["Download PDF", "Descargar PDF", "下载 PDF"],
  "Plus tard": ["Later", "Más tarde", "稍后"],
  "Annuler": ["Cancel", "Cancelar", "取消"],
  "Enregistrer": ["Save", "Guardar", "保存"],
  "Modifier": ["Edit", "Editar", "编辑"],
  "Supprimer": ["Delete", "Eliminar", "删除"],
  "Fermer": ["Close", "Cerrar", "关闭"],
  "Chargement...": ["Loading...", "Cargando...", "加载中..."],
  "Nouveau": ["New", "Nuevo", "新"],
};

const languageIndex = { en: 0, es: 1, "zh-CN": 2 };

Object.assign(fr, {
  "Connexion": ["Sign in", "Iniciar sesión", "登录"],
  "Nom d'utilisateur": ["Username", "Nombre de usuario", "用户名"],
  "Mot de passe administrateur oublié ?": ["Forgot administrator password?", "¿Olvidaste la contraseña de administrador?", "忘记管理员密码？"],
  "Système de gestion de salle de sport": ["Gym management system", "Sistema de gestión de gimnasio", "健身房管理系统"],
  "Identifiant": ["Username", "Usuario", "用户名"],
  "Mot de passe": ["Password", "Contraseña", "密码"],
  "Nouveau mot de passe": ["New password", "Nueva contraseña", "新密码"],
  "Confirmer le mot de passe": ["Confirm password", "Confirmar contraseña", "确认密码"],
  "Mot de passe oublié ?": ["Forgot password?", "¿Olvidaste tu contraseña?", "忘记密码？"],
  "Se connecter": ["Sign in", "Iniciar sesión", "登录"],
  "Retour à la connexion": ["Back to sign in", "Volver al inicio de sesión", "返回登录"],
  "Envoyer le code": ["Send code", "Enviar código", "发送验证码"],
  "Code de vérification": ["Verification code", "Código de verificación", "验证码"],
  "Vérifier": ["Verify", "Verificar", "验证"],
  "Réinitialiser le mot de passe": ["Reset password", "Restablecer contraseña", "重置密码"],
  "Sécurité": ["Security", "Seguridad", "安全"],
  "Double authentification": ["Two-factor authentication", "Autenticación en dos pasos", "双重验证"],
  "Code de récupération": ["Recovery code", "Código de recuperación", "恢复代码"],
  "Compte": ["Account", "Cuenta", "账户"],
  "Paramètres": ["Settings", "Configuración", "设置"],
  "Langue": ["Language", "Idioma", "语言"],
  "Français": ["French", "Francés", "法语"],
  "Anglais": ["English", "Inglés", "英语"],
  "Espagnol": ["Spanish", "Español", "西班牙语"],
  "Chinois simplifié": ["Simplified Chinese", "Chino simplificado", "简体中文"],
  "Ajouter": ["Add", "Añadir", "添加"],
  "Créer": ["Create", "Crear", "创建"],
  "Mettre à jour": ["Update", "Actualizar", "更新"],
  "Confirmer": ["Confirm", "Confirmar", "确认"],
  "Retour": ["Back", "Volver", "返回"],
  "Suivant": ["Next", "Siguiente", "下一步"],
  "Précédent": ["Previous", "Anterior", "上一步"],
  "Imprimer": ["Print", "Imprimir", "打印"],
  "Exporter": ["Export", "Exportar", "导出"],
  "Télécharger": ["Download", "Descargar", "下载"],
  "Actualiser": ["Refresh", "Actualizar", "刷新"],
  "Rechercher": ["Search", "Buscar", "搜索"],
  "Filtrer": ["Filter", "Filtrar", "筛选"],
  "Réinitialiser": ["Reset", "Restablecer", "重置"],
  "Aucun résultat": ["No results", "Sin resultados", "无结果"],
  "Aucune donnée disponible": ["No data available", "No hay datos disponibles", "暂无数据"],
  "Erreur lors du chargement des données": ["Error loading data", "Error al cargar los datos", "加载数据时出错"],
  "Une erreur est survenue": ["An error occurred", "Ocurrió un error", "发生错误"],
  "Opération réussie": ["Operation successful", "Operación correcta", "操作成功"],
  "En attente": ["Pending", "Pendiente", "待处理"],
  "Approuvé": ["Approved", "Aprobado", "已批准"],
  "Approuvée": ["Approved", "Aprobada", "已批准"],
  "Refusé": ["Rejected", "Rechazado", "已拒绝"],
  "Refusée": ["Rejected", "Rechazada", "已拒绝"],
  "Payé": ["Paid", "Pagado", "已支付"],
  "Échoué": ["Failed", "Fallido", "失败"],
  "En retard": ["Overdue", "Atrasado", "逾期"],
  "Inactif": ["Inactive", "Inactivo", "未启用"],
  "Abonnement": ["Subscription", "Suscripción", "订阅"],
  "Plan": ["Plan", "Plan", "套餐"],
  "Durée": ["Duration", "Duración", "时长"],
  "Jours": ["Days", "Días", "天"],
  "Heures": ["Hours", "Horas", "小时"],
  "Date de début": ["Start date", "Fecha de inicio", "开始日期"],
  "Date de fin": ["End date", "Fecha de finalización", "结束日期"],
  "Renouveler": ["Renew", "Renovar", "续订"],
  "Paiement": ["Payment", "Pago", "付款"],
  "Paiements": ["Payments", "Pagos", "付款"],
  "Montant": ["Amount", "Importe", "金额"],
  "Méthode de paiement": ["Payment method", "Método de pago", "付款方式"],
  "Espèces": ["Cash", "Efectivo", "现金"],
  "Carte bancaire": ["Bank card", "Tarjeta bancaria", "银行卡"],
  "Virement": ["Bank transfer", "Transferencia", "银行转账"],
  "Chèque": ["Cheque", "Cheque", "支票"],
  "Reçu": ["Receipt", "Recibo", "收据"],
  "Caisse du jour": ["Today’s cash register", "Caja del día", "当日收银"],
  "Dépense": ["Expense", "Gasto", "支出"],
  "Catégorie": ["Category", "Categoría", "类别"],
  "Description": ["Description", "Descripción", "描述"],
  "Justificatif": ["Receipt attachment", "Comprobante", "凭证"],
  "Budget": ["Budget", "Presupuesto", "预算"],
  "Rapports": ["Reports", "Informes", "报告"],
  "Rapport financier annuel": ["Annual financial report", "Informe financiero anual", "年度财务报告"],
  "Bilan mensuel": ["Monthly report", "Informe mensual", "月度报告"],
  "Bilan de la journée": ["Daily report", "Informe diario", "日报"],
  "Contrôle d’accès": ["Access control", "Control de acceso", "门禁管理"],
  "Accès autorisé": ["Access granted", "Acceso permitido", "允许通行"],
  "Accès refusé": ["Access denied", "Acceso denegado", "拒绝通行"],
  "Tourniquet": ["Turnstile", "Torno", "闸机"],
  "Équipements": ["Equipment", "Equipos", "设备"],
  "Imprimante": ["Printer", "Impresora", "打印机"],
  "Connexion réseau": ["Network connection", "Conexión de red", "网络连接"],
  "Hors ligne": ["Offline", "Sin conexión", "离线"],
  "Synchronisation": ["Synchronization", "Sincronización", "同步"],
  "Synchronisé": ["Synchronized", "Sincronizado", "已同步"],
  "Guide détaillé des fonctionnalités": ["Detailed feature guide", "Guía detallada de funcionalidades", "功能详细指南"],
  "Démarrage rapide": ["Quick start", "Inicio rápido", "快速开始"],
  "Télécharger le manuel (PDF)": ["Download the manual (PDF)", "Descargar el manual (PDF)", "下载使用手册（PDF）"],
  "Erreur lors de la génération du manuel": ["Error generating the manual", "Error al generar el manual", "生成手册时出错"],
  "Manuel d'utilisation": ["User manual", "Manual de usuario", "用户手册"],
  "Étapes": ["Steps", "Pasos", "步骤"],
  "Astuces": ["Tips", "Consejos", "提示"],
  "Sommaire": ["Contents", "Índice", "目录"],
  "Relances": ["Follow-ups", "Seguimientos", "提醒"],
  "Relance groupée": ["Bulk follow-up", "Seguimiento grupal", "批量提醒"],
  "Relances programmées": ["Scheduled follow-ups", "Seguimientos programados", "计划提醒"],
  "Rappels d'expiration": ["Expiry reminders", "Recordatorios de vencimiento", "到期提醒"],
  "Envoyer": ["Send", "Enviar", "发送"],
  "Programmer": ["Schedule", "Programar", "安排"],
  "WhatsApp": ["WhatsApp", "WhatsApp", "WhatsApp"],
  "Parcours Santé": ["Health journey", "Seguimiento de salud", "健康计划"],
  "Nouveau parcours": ["New journey", "Nuevo seguimiento", "新建健康计划"],
  "Objectif": ["Goal", "Objetivo", "目标"],
  "Point de contrôle": ["Checkpoint", "Punto de control", "检查点"],
  "Progression": ["Progress", "Progreso", "进度"],
  "Poids": ["Weight", "Peso", "体重"],
  "Taille": ["Height", "Altura", "身高"],
  "Consentement": ["Consent", "Consentimiento", "同意"],
  "Rapport de progression": ["Progress report", "Informe de progreso", "进度报告"],
  "Mur des réussites": ["Success wall", "Muro de éxitos", "成就墙"],
  "Aucune donnée de santé": ["No health data", "No hay datos de salud", "暂无健康数据"],
  "Utilisateurs": ["Users", "Usuarios", "用户"],
  "Nouvel utilisateur": ["New user", "Nuevo usuario", "新用户"],
  "Administrateur": ["Administrator", "Administrador", "管理员"],
  "Personnel": ["Staff", "Personal", "员工"],
  "Activer": ["Enable", "Activar", "启用"],
  "Désactiver": ["Disable", "Desactivar", "停用"],
  "Journal des connexions": ["Login history", "Historial de conexiones", "登录记录"],
  "Sauvegarde": ["Backup", "Copia de seguridad", "备份"],
  "Sauvegarde complète": ["Full backup", "Copia completa", "完整备份"],
  "Importer": ["Import", "Importar", "导入"],
  "Exporter en Excel": ["Export to Excel", "Exportar a Excel", "导出到 Excel"],
  "Configurer les plans": ["Configure plans", "Configurar planes", "配置套餐"],
  "Plan actif": ["Active plan", "Plan activo", "有效套餐"],
  "Aucun abonnement": ["No subscription", "Sin suscripción", "无订阅"],
  "Aucun paiement": ["No payment", "Sin pago", "无付款"],
  "Aucune dépense": ["No expense", "Sin gasto", "无支出"],
  "Chargement des données...": ["Loading data...", "Cargando datos...", "正在加载数据..."],
  "Enregistrer les modifications": ["Save changes", "Guardar cambios", "保存更改"],
  "Supprimer définitivement": ["Delete permanently", "Eliminar definitivamente", "永久删除"],
  "Êtes-vous sûr ?": ["Are you sure?", "¿Estás seguro?", "您确定吗？"],
  "Aucune impression enregistrée.": ["No print recorded.", "No hay impresión registrada.", "暂无打印记录。"],
  "Carte": ["Card", "Tarjeta", "卡片"],
  "Bracelet": ["Wristband", "Pulsera", "手环"],
  "QR Code": ["QR code", "Código QR", "二维码"],
  "Enregistrer le visage": ["Enroll face", "Registrar rostro", "录入人脸"],
  "Caméra": ["Camera", "Cámara", "摄像头"],
  "Prendre une photo": ["Take a photo", "Tomar una foto", "拍照"],
  "Vérification en cours...": ["Verification in progress...", "Verificación en curso...", "正在验证..."],
  "Remise à zéro des compteurs": ["Reset counters", "Restablecer contadores", "重置计数器"],
  "Supprime définitivement les données choisies pour repartir à neuf. Action irréversible, réservée à l'administrateur principal. Une sauvegarde JSON est téléchargée automatiquement avant l'effacement.": ["Permanently deletes selected data to start fresh. This irreversible action is reserved for the primary administrator. A JSON backup is downloaded automatically before deletion.", "Elimina definitivamente los datos seleccionados para empezar de nuevo. Esta acción irreversible está reservada al administrador principal. Se descarga automáticamente una copia JSON antes de borrar.", "永久删除所选数据以重新开始。此不可逆操作仅限主管理员使用。删除前会自动下载 JSON 备份。"],
  "Réinitialisation totale (usine) — tout supprimer sauf le compte administrateur principal": ["Full factory reset — delete everything except the primary administrator account", "Restablecimiento total de fábrica: eliminar todo excepto la cuenta del administrador principal", "完全恢复出厂设置——删除除主管理员账户外的所有内容"],
  "Présences (entrées / sorties)": ["Attendance (check-ins / check-outs)", "Asistencia (entradas / salidas)", "出勤（入场/离场）"],
  "Abonnements (+ échéanciers)": ["Subscriptions (+ schedules)", "Suscripciones (+ plazos)", "订阅（含付款计划）"],
  "Relances (historique + programmées)": ["Follow-ups (history + scheduled)", "Seguimientos (historial + programados)", "提醒（历史记录 + 计划）"],
  "Parcours Santé (objectifs, contrôles, rapports)": ["Health journeys (goals, check-ins, reports)", "Seguimientos de salud (objetivos, controles, informes)", "健康计划（目标、检查、报告）"],
  "Comptes staff (sauf administrateur principal)": ["Staff accounts (except primary administrator)", "Cuentas del personal (excepto administrador principal)", "员工账户（主管理员除外）"],
  "Mot de passe de l'administrateur principal": ["Primary administrator password", "Contraseña del administrador principal", "主管理员密码"],
  "Votre mot de passe admin": ["Your administrator password", "Tu contraseña de administrador", "您的管理员密码"],
  "Équipements et passerelle": ["Equipment and gateway", "Equipos y pasarela", "设备和网关"],
  "Configuration locale réservée à l’administrateur principal.": ["Local configuration reserved for the primary administrator.", "Configuración local reservada al administrador principal.", "本地配置仅限主管理员使用。"],
  "Configuration synchronisée": ["Configuration synchronized", "Configuración sincronizada", "配置已同步"],
  "Tourniquet et lecteur facial": ["Turnstile and facial reader", "Torno y lector facial", "闸机和人脸识别器"],
  "Ordinateur passerelle local": ["Local gateway computer", "Ordenador pasarela local", "本地网关电脑"],
  "Priorité 1": ["Priority 1", "Prioridad 1", "优先级 1"],
  "Priorité 2": ["Priority 2", "Prioridad 2", "优先级 2"],
  "À configurer": ["To configure", "Por configurar", "待配置"],
  "Protocole à confirmer": ["Protocol to confirm", "Protocolo por confirmar", "待确认协议"],
  "IP locale à renseigner": ["Local IP to enter", "IP local por indicar", "请输入本地 IP"],
  "Préparer test": ["Prepare test", "Preparar prueba", "准备测试"],
  "Gestion de salle de sport & suivi des membres": ["Gym management & member follow-up", "Gestión del gimnasio y seguimiento de miembros", "健身房管理和会员跟进"],
  "Les 4 étapes essentielles pour commencer": ["The 4 essential steps to get started", "Los 4 pasos esenciales para comenzar", "入门的 4 个关键步骤"],
  "Cliquez sur une section pour la déployer": ["Click a section to expand it", "Haz clic en una sección para desplegarla", "点击章节展开"],
  "Questions fréquentes": ["Frequently asked questions", "Preguntas frecuentes", "常见问题"],
  "Contact & support": ["Contact & support", "Contacto y soporte", "联系和支持"],
  "Mettre à jour les captures": ["Update captures", "Actualizar capturas", "更新截图"],
  "Gestion des utilisateurs": ["User management", "Gestión de usuarios", "用户管理"],
  "Journal d'audit": ["Audit log", "Registro de auditoría", "审计日志"],
  "Changer mon mot de passe": ["Change my password", "Cambiar mi contraseña", "修改我的密码"],
  "Rechercher un utilisateur (nom, identifiant, e-mail)...": ["Search a user (name, username, email)...", "Buscar un usuario (nombre, identificador, correo)...", "搜索用户（姓名、用户名、邮箱）..."],
  "Identifiant de connexion:": ["Login username:", "Identificador de inicio de sesión:", "登录用户名："],
  "Rôle:": ["Role:", "Rol:", "角色："],
  "Statut:": ["Status:", "Estado:", "状态："],
  "Créé le:": ["Created on:", "Creado el:", "创建于："],
  "API Tourniquet (autorisation externe)": ["Turnstile API (external authorization)", "API del torno (autorización externa)", "闸机 API（外部授权）"],
  "Lancer la borne libre-service": ["Launch self-service kiosk", "Iniciar terminal de autoservicio", "启动自助终端"],
  "Journaux d'accès": ["Access logs", "Registros de acceso", "访问日志"],
  "QR Codes actifs": ["Active QR codes", "Códigos QR activos", "有效二维码"],
  "Design bracelet": ["Wristband design", "Diseño de pulsera", "手环设计"],
  "Historique des accès au tourniquet": ["Turnstile access history", "Historial de accesos al torno", "闸机访问历史"],
  "Exporter CSV": ["Export CSV", "Exportar CSV", "导出 CSV"],
  "Exporter PDF": ["Export PDF", "Exportar PDF", "导出 PDF"],
});

Object.assign(fr, FULL_TRANSLATIONS);

const dynamicTranslation = (value, language) => {
  const index = languageIndex[language];
  const counted = value.match(/^(.+?)\s*\((\d+)\)$/);
  if (counted && fr[counted[1]]) return `${fr[counted[1]][index]} (${counted[2]})`;

  const step = value.match(/^Étape\s+(\d+)\s*\/\s*(\d+)$/);
  if (step) return [
    `Step ${step[1]} / ${step[2]}`,
    `Paso ${step[1]} / ${step[2]}`,
    `第 ${step[1]} 步 / 共 ${step[2]} 步`,
  ][index];

  const patterns = [
    [/^(\d+) dépense\(s\)$/, x => [
      `${x[1]} expense(s)`, `${x[1]} gasto(s)`, `${x[1]} 笔支出`,
    ][index]],
    [/^(\d+) accès sur la période sélectionnée$/, x => [
      `${x[1]} access event(s) in the selected period`, `${x[1]} acceso(s) en el período seleccionado`, `所选期间 ${x[1]} 条访问记录`,
    ][index]],
    [/^(\d+) (actifs|expirés)$/, x => {
      const word = x[2] === "actifs" ? ["active", "activos", "有效"][index] : ["expired", "vencidos", "已过期"][index];
      return index === 2 ? `${x[1]} 个${word}` : `${x[1]} ${word}`;
    }],
    [/^Présences d'aujourd'hui \((\d+)\)$/, x => [
      `Today's attendance (${x[1]})`, `Asistencias de hoy (${x[1]})`, `今日出勤（${x[1]}）`,
    ][index]],
    [/^En cours \((\d+)\)$/, x => [
      `In progress (${x[1]})`, `En curso (${x[1]})`, `进行中（${x[1]}）`,
    ][index]],
    [/^Terminés \((\d+)\)$/, x => [
      `Completed (${x[1]})`, `Finalizados (${x[1]})`, `已完成（${x[1]}）`,
    ][index]],
    [/^Durée \((heures|jours)\)$/, x => {
      const unit = x[1] === "heures" ? ["hours", "horas", "小时"][index] : ["days", "días", "天"][index];
      return ["Duration", "Duración", "时长"][index] + ` (${unit})`;
    }],
    [/^(\d+) restant\(s\)$/, x => [
      `${x[1]} remaining`, `${x[1]} restante(s)`, `剩余 ${x[1]} 个`,
    ][index]],
    [/^Rapport financier annuel\s+(.+)$/, x => [
      `Annual financial report ${x[1]}`, `Informe financiero anual ${x[1]}`, `年度财务报告 ${x[1]}`,
    ][index]],
    [/^Début\s+(.+)$/, x => [
      `Start ${x[1]}`, `Inicio ${x[1]}`, `开始 ${x[1]}`,
    ][index]],
    [/^(⚠️\s*)?Offre expirée le\s+(.+)\s+— à renouveler$/, x => [
      `${x[1] || ""}Offer expired on ${x[2]} — renew`, `${x[1] || ""}Oferta vencida el ${x[2]} — renovar`, `${x[1] || ""}优惠于 ${x[2]} 到期——需要更新`,
    ][index]],
    [/^Expiré depuis\s+(\d+)\s+j$/, x => [
      `Expired ${x[1]} days ago`, `Venció hace ${x[1]} días`, `已过期 ${x[1]} 天`,
    ][index]],
    [/^— expire le\s+(.+)$/, x => [
      `— expires on ${x[1]}`, `— vence el ${x[1]}`, `——到期日 ${x[1]}`,
    ][index]],
    [/^⚠️ À renouveler : Offre bienvenue expirée \((.+)\) · Offre anniversaire expirée \((.+)\)$/, x => [
      `⚠️ Renew: welcome offer expired (${x[1]}) · birthday offer expired (${x[2]})`,
      `⚠️ Renovar: oferta de bienvenida vencida (${x[1]}) · oferta de cumpleaños vencida (${x[2]})`,
      `⚠️ 需要更新：欢迎优惠已到期（${x[1]}）· 生日优惠已到期（${x[2]}）`,
    ][index]],
    [/^· mémorisé le\s+(.+)$/, x => [
      `· remembered on ${x[1]}`, `· recordado el ${x[1]}`, `· 记住于 ${x[1]}`,
    ][index]],
  ];
  for (const [pattern, render] of patterns) {
    const match = value.match(pattern);
    if (match) return render(match);
  }
  return value;
};

export const translateFrench = (value, language) => {
  if (language === "fr") return value;
  const translation = fr[value]?.[languageIndex[language]];
  return translation || dynamicTranslation(value, language);
};

export const translateStaticFrenchText = (value, language) => {
  if (language === "fr" || typeof value !== "string") return value;
  return translateFrench(value, language);
};

export const translateDocumentLine = (value, language) => {
  const exact = translateStaticFrenchText(value, language);
  if (exact !== value || language === "fr") return exact;
  const prefix = Object.entries(fr)
    .filter(([source]) => source.endsWith(":") || source.endsWith(" :"))
    .sort(([first], [second]) => second.length - first.length)
    .find(([source]) => value.startsWith(source));
  return prefix ? `${prefix[1][languageIndex[language]] || prefix[0]}${value.slice(prefix[0].length)}` : value;
};

export const dashboardCountLabel = (kind, count, language) => {
  const labels = {
    birthday: {
      fr: `${count} anniversaire${count > 1 ? "s" : ""} à souhaiter`,
      en: `${count} birthday${count !== 1 ? "s" : ""} to celebrate`,
      es: `${count} cumpleaños${count !== 1 ? "" : ""} por celebrar`,
      "zh-CN": `${count} 个生日待庆祝`,
    },
    welcome: {
      fr: `${count} bienvenue${count > 1 ? "s" : ""} à envoyer`,
      en: `${count} welcome message${count !== 1 ? "s" : ""} to send`,
      es: `${count} mensaje${count !== 1 ? "s" : ""} de bienvenida por enviar`,
      "zh-CN": `${count} 条欢迎消息待发送`,
    },
    present: {
      fr: `${count} présent${count > 1 ? "s" : ""}`,
      en: `${count} present`,
      es: `${count} presente${count !== 1 ? "s" : ""}`,
      "zh-CN": `${count} 人在场`,
    },
  };
  return labels[kind]?.[language] || labels[kind]?.fr || String(count);
};